import { jsx as _jsx } from "preact/jsx-runtime";
/* eslint-disable no-case-declarations */
import { FieldType, } from '@widgets/EnquiryForm/types/config';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import NumberInput from '@widgets/shared/components/form-controls/NumberInput';
import DropdownInput from '@widgets/shared/components/form-controls/DropdownInput';
import RadioInput from '@widgets/shared/components/form-controls/RadioInput';
import DatepickerInput from '@widgets/shared/components/form-controls/DatepickerInput';
import TextareaInput from '@widgets/shared/components/form-controls/TextareaInput';
import ContentBlock from '@widgets/shared/components/form-controls/ContentBlock';
import HiddenInput from '@widgets/shared/components/form-controls/HiddenInput';
import sanitizeTitle from '@widgets/shared/sanitizeTitle';
import CaptchaInput from '@widgets/shared/components/form-controls/CaptchaInput';
import indepthDatepickerDay from '@genericBookings/components/IndepthDatepicker/Components/IndepthDatepickerDay/IndepthDatepickerDay';
export default function FormField(props) {
    const { type } = props;
    // If is just HTML bail out of the rest of the stuff
    if (type === FieldType.HTMLContent) {
        const contentProps = props;
        return _jsx(ContentBlock, { ...contentProps });
    }
    const { id, name, placeholder, label, hideLabel, required, defaultValue, forceError, ...miscProps } = props;
    const fieldId = id || `${sanitizeTitle(name)}-input`;
    const inputDefaults = {
        ...miscProps,
        name: name,
        id: fieldId,
        placeholder,
    };
    const labelDefaults = {
        htmlFor: fieldId,
        text: label ?? undefined,
        hidden: hideLabel ?? false,
        isFieldRequired: required,
    };
    switch (type) {
        case FieldType.NumberInput:
            const { min, max, } = props;
            return (_jsx(NumberInput, { inputAttrs: {
                    ...inputDefaults,
                    min,
                    max,
                    type: 'number',
                }, labelAttrs: labelDefaults }));
        case FieldType.TextareaInput:
            return (_jsx(TextareaInput, { inputAttrs: inputDefaults, labelAttrs: labelDefaults }));
        case FieldType.PhoneInput:
            return (_jsx(TextInput, { inputAttrs: {
                    ...inputDefaults,
                    type: 'tel',
                    inputMode: 'tel',
                }, labelAttrs: labelDefaults, forceError: forceError }));
        case FieldType.DropdownInput:
            return (_jsx(DropdownInput, { inputAttrs: {
                    ...inputDefaults,
                    options: props.options ?? [],
                }, labelAttrs: labelDefaults }));
        case FieldType.RadioInput:
        case FieldType.CheckboxInput:
            return (_jsx(RadioInput, { labelAttrs: { ...labelDefaults }, options: props.options ?? [], name: name, type: type === FieldType.CheckboxInput ? 'checkbox' : 'radio' }));
        case FieldType.TimepickerInput:
        case FieldType.DatepickerInput:
            const { placeholder: placeholderText, ...dateInputDefaults } = inputDefaults;
            const datePickerProps = props;
            return (_jsx(DatepickerInput, { type: type === FieldType.TimepickerInput ? 'time' : 'date', labelAttrs: labelDefaults, inputAttrs: {
                    ...dateInputDefaults,
                    showTimeSelect: type === FieldType.TimepickerInput,
                    showTimeSelectOnly: type === FieldType.TimepickerInput,
                    dateFormat: datePickerProps.dateFormat,
                    minDate: datePickerProps.minDate,
                    maxDate: datePickerProps.maxDate,
                    endDate: datePickerProps.maxDate,
                    startDate: datePickerProps.minDate,
                    shouldCloseOnSelect: true,
                    yearDropdownItemNumber: 1,
                    placeholderText,
                    inline: false,
                    showPopperArrow: true,
                    isClearable: false,
                    renderDayContents: indepthDatepickerDay,
                } }));
        case FieldType.Hidden:
            return (_jsx(HiddenInput, { inputAttrs: inputDefaults }));
        case FieldType.Captcha:
            return (_jsx(CaptchaInput, { inputAttrs: { ...inputDefaults, type: 'image' }, labelAttrs: labelDefaults }));
        case FieldType.Password:
            return (_jsx(TextInput, { inputAttrs: {
                    ...inputDefaults,
                    type: 'password',
                }, labelAttrs: labelDefaults }));
        case FieldType.EmailInput:
        case FieldType.TextInput:
        default:
            return (_jsx(TextInput, { inputAttrs: {
                    ...inputDefaults,
                    type: type === 'email' ? 'email' : 'text',
                }, labelAttrs: labelDefaults }));
    }
}
